import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;

export const { thunk: disableFlashSale, slice: disableFlashSaleSlice } = getThunkAndSlice<Array<number>, typeof initialState>({
	initialState,
	path: "/api/Pricing/DisableFlashSale",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = getInventoryCacheEventId(rootState);
		const inventoryAllState = rootState.pricing.eventInventoryAll.data;
		const newData = inventoryAllState.map((x) => {
			return x.Listing_ID === params[0] ? { ...x, FlashSaleEnabled: null, FlashSaleDiscount: null } : x;
		});

		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((x) => {
				return x.Listing_ID === params[0] ? { ...x, FlashSaleEnabled: null, FlashSaleDiscount: null } : x;
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
